import type { ReactNode } from 'react'
import './Tag.css'

export type TagVariant = 'primary' | 'coral' | 'neutral'

export interface TagProps {
  variant: TagVariant
  children: ReactNode
}

export function Tag({ variant, children }: TagProps) {
  return <span className={`azoya-tag azoya-tag--${variant}`}>{children}</span>
}
